/**
 * Dealer portal sign in url
 * @type {string}
 */
export const OKTA_DEALER_PORTAL_URL = 'https://edmundsdealerportal.okta.com/';
